var partners = ['allstate', 'encompass', 'one-beacon', 'aviva', 'nationwide', 'state-farm', 'chiron'];

export { partners };
